<template>
    <div>
  <el-card class="aui-card--fill"
                shadow="never">
        <el-form
                label-position="top"
                label-width="145px"
                :model="inServForm"
                v-loading="dataListLoading"
                ref="inServForm"
                size="small">
            <el-row style="background-color:#ebecf0 !important">
                <div class="opten-titlec">
                    课程介绍
                </div>
            <el-col :span="24">
                <div style="text-align:center;padding: 15px 15px;"  >
                <!--课程介绍-->
                 {{inServForm.offeringform.courseIntroductionCn}}
            </div>
            </el-col>
            </el-row>
            <!-- ************************基本信息*********************************-->
            <!-- 排期信息显示 -->
            <el-row>
                <div class="opten-titlec">
                    课程信息
                </div>
                <el-col :span="6">
                    <!-- 课程名称 -->
                    <el-form-item label="课程名称"
                                  prop="courseCode">
                        {{inServForm.offeringform.courseCode}}
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <!-- 课程价格 -->
                    <el-form-item label="课程价格(元)"
                                  prop="coursePrice">
                        {{inServForm.offeringform.coursePrice}}
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <!-- 标准时长(天) -->
                    <el-form-item label="标准时长(天)"
                                  prop="courseCode">
                        {{inServForm.offeringform.courseDays}}
                    </el-form-item>
                </el-col>

            </el-row>

            <span style="color:#F99403;font-size:13px">为了提升学员参加面授课的学习质量和效率，请报名前务必关注《课程报名前提》和《课前学习要求》中的要求。</span>
            <!-- ************************列表* type="border-card"********************************-->
            <el-tabs v-model="offeringValue">
                <el-tab-pane label="课程报名前提" name="10">
                    <div style="margin-bottom:10px;" >
                    <span style="color:#F99403;font-size:13px">报名本面授课前首先需要满足以下任意一个选项的要求。如在报名时前提条件允许“已报名”状态，需要按照要求完成以下学习，如未完成会导致报名取消和产生扣款。</span>
                    </div>
                    <el-table :data="infiledLists2"
                              :show-header="false"
                              style="width: 100%;text-align: left;"
                              class="el-table el-table"
                              :cell-style="cellStyle"
                              border
                              stripe
                              empty-text=" ">
                        <el-table-column label="coursecode"
                                         prop="options"
                                         min-width="100px"
                                         width="400px"
                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus' + scope.$index">{{$t('couse.allname')}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="coursecode"
                                         prop="optype"
                                         min-width="80px"
                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus3' + scope.$index">{{$t('couse.alltype')}}</span>
                            </template>
                        </el-table-column>
<!--                        width="400px"-->
                        <el-table-column label="coursecode"
                                         prop="state"
                                         min-width="90px"

                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus2' + scope.$index">要求完成状态</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="coursecode"
                                         prop="state"
                                         min-width="90px"
                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus2' + scope.$index">学员当前状态</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            :data="inServForm.courseConditionList"
                            id="download2"
                            :show-header="false"
                            :cell-style="cellStylec"
                            border
                            stripe
                            empty-text=" "
                    >
                        <el-table-column label=""
                                         min-width="140px"
                                         align="left">
                            <template slot-scope="scope">
                                <conditionShow
                                        :inputvaluestrue22="scope.row.traineeCourseConditionStatus"
                                        :inputvalues="scope.row.singleCourseConditionList"
                                        :inputvalues22="scope.row.singleCourseConditionList[0].optionIndex"
                                       ></conditionShow>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <!-- ***************课前学习要求 FF9933******** 开始****************-->
                <el-tab-pane label="课前学习要求" name="20" v-if="inServForm.courseBlendConditionList.length>0">
                    <div style="margin-bottom:10px;" >
                    <span style="color:#F99403;font-size:13px">参加本面授课前需要完成以下混合式学习课程中的在线学习。如在报名时学习要求允许“已报名”状态，需要按照要求完成以下学习，如未完成会导致报名取消和产生扣款。</span>
                    </div>
                        <!--                    <div class="location-layout" v-if="inServForm.offeringBlendRead == '0'">-->
<!--                        <div style="margin-bottom:1px;" v-if="courseBlendDisplay==true">-->
                    <div class="location-layout" >
                        <div style="margin-bottom:1px;" >
                            <el-table :data="infiledLists2"
                                      :show-header="false"
                                      style="width: 100%;text-align: left;"
                                      class="el-table el-table"
                                      :cell-style="cellStyle"
                                      border
                                      stripe
                                      empty-text=" ">
                                <el-table-column label="coursecode"
                                                 prop="options"
                                                 min-width="100px"
                                                 width="400px"
                                                 align="center">
                                    <template slot-scope="scope">
                                        <span :id="'completeStatus' + scope.$index">{{$t('couse.allname')}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="coursecode"
                                                 prop="optype"
                                                 min-width="80px"
                                                 align="center">
                                    <template slot-scope="scope">
                                        <span :id="'completeStatus3' + scope.$index">{{$t('couse.alltype')}}</span>
                                    </template>
                                </el-table-column>
<!--                                width="400px"-->
                                <el-table-column label="coursecode"
                                                 prop="state"
                                                 min-width="90px"

                                                 align="center">
                                    <template slot-scope="scope">
                                        <span :id="'completeStatus2' + scope.$index">要求完成状态</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="coursecode"
                                                 prop="state"
                                                 min-width="90px"
                                                 align="center">
                                    <template slot-scope="scope">
                                        <span :id="'completeStatus2' + scope.$index">学员当前状态</span>
                                    </template>
                                </el-table-column>                            </el-table>
                            <el-table
                                    :data="inServForm.courseBlendConditionList"
                                    id="download1"
                                    :show-header="false"
                                    :cell-style="cellStylec"
                                    border
                                    stripe
                                    empty-text=" "
                            >
                                <el-table-column label=""
                                                 min-width="140px"
                                                 align="left">
                                    <template slot-scope="scope">
                                        <blendconditionShow
                                                            :inputvaluestrue22="scope.row.traineeCourseConditionStatus"
                                                            :inputvalues="scope.row.blendConditionOfOfferingDTOList"
                                                            :inputvalues22="scope.row.blendConditionOfOfferingDTOList[0].optionIndex"
                                                            ></blendconditionShow>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- ***************课前学习要求 ******** 结束****************-->
            </el-tabs>

          </el-form>
       </el-card>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import conditionShow from './offeringconditionzShow'
import blendconditionShow from './blendofferingconditionzShow'
import ZElButton from '../../../common/button/index'

export default {
// import引入的组件需要注入到对象中才能使用
  components: {
    ZElButton,
    conditionShow ,
    blendconditionShow
  },
    props: {'message':String , 'passOfferingId':String, 'isShowEdit':String,'showOfferingDate':Array},
  data () {
    return {
      offeringValue: '10',
      dataListLoading: true,
      initIsShowEdit:'',
      mixinViewModuleOptions: {
          // getRegisteredDataListURL: '/learning/offeringregiste/selectRegistrationStaff',
          getRegisteredDataListURL: '/learning/offeringTrainerApp/showCourse',
      },
      dialogTableVisible: false,
      courseId: '',
      importExcelVisible1: false,
      importExcelVisible: false,
      initcon: [],
      infiledLists2: [{ options: 1 }],
      courseBlendDisplay:false,
      inputvaluesDate:{},
      inServForm: {
          offeringform:{
              courseIntroductionCn: '',
              userName:'',
              userCode:'',
              courseName:'',
              courseCode:'',
              offeringNo:'',
              siteName:'',
              offeringStartDateFmt:'',
              offeringEndDateFmt:''
          },
          offeringId: '',
          courseId: '',
          courseConditionList:[],
          courseBlendConditionList:[],
          courseTeamCatalogSecond:''
      },
      dataForm: {
        offeringId: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {

  },
  // 监控data中的数据变化
  watch: {
      showOfferingDate: function(newVal,oldVal){
          //this.inputvaluesDate = newVal; //newVal即是chartData
      }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
      this.dataForm.offeringId = this.$route.query.offeringId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  /* mounted () {
      console.log('mounted');
  }, */
  beforeCreate () {
      console.log('beforeCreate');
  }, // 生命周期 - 创建之前
  beforeMount () {
      console.log('beforeMount');
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
      console.log('beforeUpdate');
  }, // 生命周期 - 更新之前
  updated () {
      console.log('updated');
  }, // 生命周期 - 更新之后
  beforeDestroy () {
      console.log('beforeDestroy');
  }, // 生命周期 - 销毁之前
  destroyed () {
      console.log('destroyed');
  }, // 生命周期 - 销毁完成
  activated () {
      console.log('activated');
  },
  // 方法集合
  mounted () {
        /* eslint-disable */
        // debugger
        //this.initQuery()
        this.$eventHub.$on('courseshowqt', (data) => {
            this.getDataList()
        })
    },
  methods: {
     inputvaluesDatelistreplace(row,offeringid){
          this.offeringValue = '10'
          console.info('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>'+offeringid+JSON.stringify(row))
          this.inputvaluesDate=row
          this.getDataList(row.userCode,offeringid)
      },
      // 获取数据列表
     getDataList () {
         this.dataListLoading = true
         this.inServForm.offeringform={}
         this.inServForm.courseConditionList=[]
         this.inServForm.courseBlendConditionList=[]
         this.$request.get(
             this.mixinViewModuleOptions.getRegisteredDataListURL,
             {
                 courseId: this.$route.query.courseId
             }
         ).then((res, total, code, data) => {
             console.log(JSON.stringify(">>>>>>>>>>>>>>>>"+data.data))
             this.inServForm.offeringform=data.data
             this.inServForm.courseConditionList = data.data.courseOptionConditionList
             if(data.data.offeringBlendCourseConditionList != null){
                 this.inServForm.courseBlendConditionList = data.data.offeringBlendCourseConditionList
             }
             this.dataListLoading=false

         }).catch((err) => {
             console.log(err)
         })
     },

    cellStylec ({ row, column, rowIndex, columnIndex }) {
      return {
        background: '#fff'
      }
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property) {
        return {
          background: '#ebecf0 !important',
          color: '#333333'
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
 .el-form--label-top .el-form-item__label {
    padding: 0px !important;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.opten-titlec {
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
}
  // @import url(); 引入公共css类
  .grid-content {
      border-radius: 4px;
      min-height: 36px;
  }
  .box1 {
    float: left;
  }
  .box2 {
    float: left;
  }
</style>
